import {Injectable} from '@angular/core';
import {LogLevel} from './log-level.enum';
import {environment} from '~/environments/environment';

/**
 * @description Logger service for environment logging.
 *
 * Inject the Logger in your main component (i.e. AppComponent)
 * to use logging after the component is loaded.
 * You don't need to explicitly call its init() method
 * (done automatically when the service's constructor gets called upon instantiation By Angular).
 */
@Injectable({
  providedIn: 'root'
})
export class Logger {
  private static level: LogLevel = LogLevel.DEBUG;

  constructor() {
    Logger.level = LogLevel[environment.LOG_LEVEL];
  }

  public static debug(...message: any): void {
    Logger.writeToLog(LogLevel.DEBUG, ...message);
  }

  public static log(...message: any) {
    Logger.writeToLog(LogLevel.INFO, ...message);
  }

  public static warn(...message: any) {
    Logger.writeToLog(LogLevel.WARN, ...message);
  }

  public static error(...message: any) {
    Logger.writeToLog(LogLevel.ERROR, ...message);
  }

  private static shouldLog(level: LogLevel): boolean {
    return (level >= this.level);
  }

  private static writeToLog(level: LogLevel, ...message: any) {
    if (this.shouldLog(level)) {
      if (level <= LogLevel.INFO) {
        console.log(Logger.getLogDate(), ...message);
      } else if (level === LogLevel.ERROR) {
        console.error(Logger.getLogDate(), ...message);
      } else if (level === LogLevel.WARN) {
        console.warn(Logger.getLogDate(), ...message);
      }
    }
  }

  private static getLogDate(): string {
    const date = new Date();
    return '[' +
      date.getUTCFullYear() + '/' +
      (date.getUTCMonth() + 1) + '/' +
      date.getUTCDate() + ' ' +
      date.getUTCHours() + ':' +
      date.getUTCMinutes() + ':' +
      date.getUTCSeconds() + '.' +
      date.getMilliseconds() + ']';
  }
}
